import { type I18n, createI18n } from "vue-i18n";

import messages from "@/lang";
import { languages } from "@/constants/languages";
import type { IApp } from "@/types/app";

const initI18n = (app: IApp): I18n => {
  const localeMessage: Record<string, Record<string, string>> = {
    ...(messages as unknown as Record<string, Record<string, string>>),
  };

  const user = app.$cookies.get("user") ?? {};
  const language = languages.find(language => language.value == user.languageId) ?? languages[0];

  return createI18n({
    locale: language.locale, // set fallback locale
    legacy: false, // you must set `false`, to use Compostion API
    messages: localeMessage, // set locale messages
  });
};

export default initI18n;
